/**
 * Coups de pouce — Attendu 686 « Utiliser des échelles simples (plan, carte) ».
 * Une entrée par generator_key (cf. gen_686.js).
 */

// ── Plan → réel : multiplier par l'échelle, puis convertir (id cp686play1) ──
// Échelle 1/400 et segment de 3 cm : valeurs hors des pools du format.
const SVG_P2R_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 190" role="img"
     aria-label="Un plan à l'échelle 1 sur 400 montre un segment de 3 centimètres. Le calcul 3 fois 400 égale 1200 centimètres apparaît en vert, puis la conversion 1200 centimètres égale 12 mètres en orange">
  <g id="cp686play1" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- le plan et son segment -->
  <g opacity="0">
    <rect x="15" y="44" width="150" height="80" rx="4" fill="none" stroke="#1E3A8A" stroke-width="1.2"/>
    <text x="90" y="60" font-size="11" font-weight="600" fill="#1E3A8A" text-anchor="middle" font-family="system-ui,sans-serif">Échelle 1/400</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play1.click+0.3s" fill="freeze"/>
  </g>
  <!-- le segment mesuré -->
  <g opacity="0">
    <line x1="40" y1="100" x2="130" y2="100" stroke="#0f172a" stroke-width="2"/>
    <line x1="40" y1="94" x2="40" y2="106" stroke="#0f172a" stroke-width="2"/>
    <line x1="130" y1="94" x2="130" y2="106" stroke="#0f172a" stroke-width="2"/>
    <text x="85" y="90" font-size="11" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">3 cm</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play1.click+1.2s" fill="freeze"/>
  </g>
  <!-- étape 1 : multiplier par l'échelle -->
  <text x="258" y="84" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">3 × 400 = 1200 cm<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play1.click+2.6s" fill="freeze"/></text>
  <!-- étape 2 : convertir en mètres -->
  <text x="258" y="108" font-size="13" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">1200 cm = 12 m<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play1.click+4.2s" fill="freeze"/></text>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="146" width="8" height="8" rx="2" fill="#1D9E75"/>
    <text x="36" y="154" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Multiplie par l'échelle : le résultat est en cm.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play1.click+5.4s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="168" width="8" height="8" rx="2" fill="#B45309"/>
    <text x="36" y="176" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Convertis ensuite en mètres (100 cm = 1 m).</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play1.click+6s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_PLAN_VERS_REEL = {
    pages: [
        {
            titre: 'La méthode',
            svg: SVG_P2R_ANIM,
        },
    ],
};

// ── Réel → plan : convertir en cm, puis diviser par l'échelle (id cp686play2) ──
// Échelle 1/40 et vestiaire de 2 m : valeurs hors des pools du format.
const SVG_R2P_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 190" role="img"
     aria-label="Un vestiaire mesure 2 mètres en réalité. Sur un plan à l'échelle 1 sur 40, la conversion 2 mètres égale 200 centimètres apparaît en vert, puis la division 200 divisé par 40 égale 5 centimètres en orange remplit la longueur inconnue du plan">
  <g id="cp686play2" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- la donnée réelle + le cadre du plan -->
  <g opacity="0">
    <text x="15" y="38" font-size="11" font-weight="700" fill="#0f172a" font-family="system-ui,sans-serif">Un vestiaire mesure 2 m en réalité.</text>
    <rect x="15" y="44" width="150" height="80" rx="4" fill="none" stroke="#1E3A8A" stroke-width="1.2"/>
    <text x="90" y="60" font-size="11" font-weight="600" fill="#1E3A8A" text-anchor="middle" font-family="system-ui,sans-serif">Échelle 1/40</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play2.click+0.3s" fill="freeze"/>
  </g>
  <!-- le segment du plan, longueur inconnue puis 5 cm -->
  <g opacity="0">
    <line x1="40" y1="100" x2="130" y2="100" stroke="#0f172a" stroke-width="2"/>
    <line x1="40" y1="94" x2="40" y2="106" stroke="#0f172a" stroke-width="2"/>
    <line x1="130" y1="94" x2="130" y2="106" stroke="#0f172a" stroke-width="2"/>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play2.click+1.2s" fill="freeze"/>
  </g>
  <text x="85" y="90" font-size="11" font-weight="700" fill="#94a3b8" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">? cm<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play2.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play2.click+1.2s" fill="freeze"/><animate attributeName="opacity" values="1;0" dur="0.25s" begin="cp686play2.click+4.2s" fill="freeze"/></text>
  <text x="85" y="90" font-size="11" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">5 cm<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play2.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play2.click+4.3s" fill="freeze"/></text>
  <!-- étape 1 : convertir en cm -->
  <text x="258" y="84" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">2 m = 200 cm<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play2.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play2.click+2.6s" fill="freeze"/></text>
  <!-- étape 2 : diviser par l'échelle -->
  <text x="258" y="108" font-size="13" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">200 ÷ 40 = 5 cm<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play2.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play2.click+4.2s" fill="freeze"/></text>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="146" width="8" height="8" rx="2" fill="#1D9E75"/>
    <text x="36" y="154" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Convertis d'abord en cm (1 m = 100 cm).</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play2.click+5.4s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="168" width="8" height="8" rx="2" fill="#B45309"/>
    <text x="36" y="176" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Divise par l'échelle : le résultat est en cm.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play2.click+6s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_REEL_VERS_PLAN = {
    pages: [
        {
            titre: 'La méthode',
            svg: SVG_R2P_ANIM,
        },
    ],
};

// ── Choix d'échelle : tester une échelle et regarder si le dessin tient ──
// Règle sobre sans exemple chiffré (décision utilisateur 2026-08-11).
const CP_CHOIX_ECHELLE = {
    pages: [
        {
            titre: 'La méthode',
            lignes: [
                'Convertis la taille réelle en cm, puis divise par n : tu obtiens la taille du dessin.',
                'La bonne échelle donne un dessin qui tient sur la feuille, de quelques cm à 30 cm.',
            ],
        },
    ],
};

// ── Carte → réel avec conversion en km (id cp686play3) ──
// Carte au 1/300 000 et 2 cm : valeurs hors des pools du format.
const SVG_CONV_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 190" role="img"
     aria-label="Une carte à l'échelle 1 sur 300 000 montre un segment de 2 centimètres entre deux lieux. Le calcul 2 fois 300 000 égale 600 000 centimètres apparaît en vert, puis la conversion 600 000 centimètres égale 6 kilomètres en orange">
  <g id="cp686play3" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- la carte et son segment -->
  <g opacity="0">
    <rect x="15" y="44" width="150" height="80" rx="4" fill="none" stroke="#1E3A8A" stroke-width="1.2"/>
    <text x="90" y="60" font-size="11" font-weight="600" fill="#1E3A8A" text-anchor="middle" font-family="system-ui,sans-serif">Échelle 1/300 000</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play3.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play3.click+0.3s" fill="freeze"/>
  </g>
  <g opacity="0">
    <circle cx="50" cy="100" r="3" fill="#0f172a"/>
    <circle cx="120" cy="100" r="3" fill="#0f172a"/>
    <line x1="53" y1="100" x2="117" y2="100" stroke="#0f172a" stroke-width="2" stroke-dasharray="4 3"/>
    <text x="85" y="90" font-size="11" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">2 cm</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play3.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play3.click+1.2s" fill="freeze"/>
  </g>
  <!-- étape 1 : multiplier par l'échelle -->
  <text x="258" y="84" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">2 × 300 000 = 600 000 cm<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play3.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play3.click+2.6s" fill="freeze"/></text>
  <!-- étape 2 : convertir en km -->
  <text x="258" y="108" font-size="13" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">600 000 cm = 6 km<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play3.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play3.click+4.2s" fill="freeze"/></text>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="146" width="8" height="8" rx="2" fill="#1D9E75"/>
    <text x="36" y="154" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Multiplie par l'échelle : le résultat est en cm.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play3.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play3.click+5.4s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="168" width="8" height="8" rx="2" fill="#B45309"/>
    <text x="36" y="176" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Convertis en km (100 000 cm = 1 km).</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp686play3.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp686play3.click+6s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_CONVERSION = {
    pages: [
        {
            titre: 'La méthode',
            svg: SVG_CONV_ANIM,
        },
    ],
};

const CP_686 = {
    plan_vers_reel_saisie: CP_PLAN_VERS_REEL,
    reel_vers_plan_saisie: CP_REEL_VERS_PLAN,
    choix_echelle_qcm: CP_CHOIX_ECHELLE,
    conversion_saisie: CP_CONVERSION,
};

export default CP_686;
